import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IHangboardDropDownProps extends WithTranslation{
    handleChanges: any;
    value: string
}

const HangboardDropDown =(props: IHangboardDropDownProps) =>{
    const selectOptions = [
        { key: "none", text: "None", value: "none" }, 
        { key: "beastmaker1000", text: "Beastmaker1000", value: "beastmaker1000" },
        { key: "beastmaker2000", text: "Beastmaker2000", value: "beastmaker2000" },
        { key: "monsterboard", text: "Monster Board", value: "monsterboard" },
        { key: "tensionGrindstonePro", text: "Tension Grindstone Pro", value: "tensionGrindstonePro" },
        { key: "trango", text: "Trango Rock Prodigy", value: "trango" }  ,
        { key: "globe", text: "Globe", value: "globe" }    ,
        { key: "lemur", text: "Lemur", value: "lemur" }  
    ];
    return(<Dropdown
        placeholder={props.t('placeholder.subtype')}
        fluid
        selection
        options={selectOptions}
        onChange={props.handleChanges}
        id='hangboardDropdown'
        value={props.value}
  />)
}

export default withTranslation('exerciseCreator')(HangboardDropDown);